import request from '@/utils/request'
import SERVICE from './enums'

// 登录
export function login(data) {
  return request({
    url: `${SERVICE.API_MEDIA}/datasource/{id}/fields`,
    method: 'post',
    data
  })
}

// 查询媒体数据
export function findFieldsByCode({ params, data }) {
  return request({
    url: `${SERVICE.API_MEDIA}/datasource/findFieldsByCode`,
    method: 'post',
    params,
    data
  })
}

// 绑定授权
export function mediaOAuthBind(params) {
  return request({
    url: `${SERVICE.API_MEDIA}/mediaOAuth/bind`,
    method: 'get',
    params
  })
}
// 绑定授权
export function mediaOAuthBindPath(params) {
  return request({
    url: `${SERVICE.API_MEDIA}/mediaOAuth/bindPath`,
    method: 'get',
    params
  })
}
// 解绑
export function mediaOAuthUnbind(data) {
  return request({
    url: `${SERVICE.API_MEDIA}/mediaOAuth/unbind`,
    method: 'post',
    data
  })
}
// 查询媒体用户列表
export function getMediaUserInfo(params) {
  return request({
    url: `${SERVICE.API_MEDIA}/${params.urlName}/users`,
    method: 'get',
    params
  })
}

// 查询用户账号列表
export function pageAccount(data) {
  return request({
    url: `${SERVICE.API_MEDIA}/${data.urlName}/${data.userId}/accounts`,
    method: 'post',
    data
  })
}

// 查询gg用户列表
export function getGGUsers(params) {
  return request({
    url: `${SERVICE.API_MEDIA}/google/users`,
    method: 'get',
    params
  })
}

// 查询gg用户下的MCC
export function getGoogleMcc(data) {
  return request({
    url: `${SERVICE.API_MEDIA}/google/pageMccOfUser`,
    method: 'post',
    data
  })
}

// 查询ggMCC下的账号
export function ggAccountOfMcc(data) {
  return request({
    url: `${SERVICE.API_MEDIA}/google/pageAccountOfMcc`,
    method: 'post',
    data
  })
}

// 查询上次gg同步MCC成功时间
export function synGoogleMccTime({ userId }) {
  return request({
    url: `${SERVICE.API_MEDIA}/google/getMccSynTime`,
    method: 'get',
    params: {
      ggUserId: userId
    }
  })
}

// 按google用户ID同步MCC
export function synGoogleMcc(params) {
  return request({
    url: `${SERVICE.API_MEDIA}/google/synGoogleMcc`,
    method: 'get',
    params
  })
}

// 查询fb用户列表
export function getFBUsers(params) {
  return request({
    url: `${SERVICE.API_MEDIA}/facebook/users`,
    method: 'get',
    params
  })
}

// 查询上次同步BM成功时间
export function getBmSynTime({ userId }) {
  return request({
    url: `${SERVICE.API_MEDIA}/facebook/getBmSynTime`,
    method: 'get',
    params: {
      fbUserId: userId
    }
  })
}

// 查询FBBM下的账号
export function fbPageAccountOfBm(data) {
  return request({
    url: `${SERVICE.API_MEDIA}/facebook/pageAccountOfBm`,
    method: 'post',
    data
  })
}

// 根据FbUser分页查BM
export function pageBmOfUser(data) {
  return request({
    url: `${SERVICE.API_MEDIA}/facebook/pageBmOfUser`,
    method: 'post',
    data
  })
}

// 按facebook用户ID同步BM
export function fbSynBM({ userId }) {
  return request({
    url: `${SERVICE.API_MEDIA}/facebook/synBM`,
    method: 'get',
    params: {
      fbUserId: userId
    }
  })
}

// 查询巨量用户列表
export function getOEUsers(params) {
  return request({
    url: `${SERVICE.API_MEDIA}/oceanengine/users`,
    method: 'get',
    params
  })
}

// 查询巨量上次同步成功时间
export function getOESynTime({ userId }) {
  return request({
    url: `${SERVICE.API_MEDIA}/oceanengine/${userId}/accounts/syncTime`,
    method: 'get',
    params
  })
}

// 查询巨量用户下的账号
export function oePageAccount({ userId }) {
  return request({
    url: `${SERVICE.API_MEDIA}/oceanengine/${userId}/accounts`,
    method: 'post',
    data
  })
}

// 按OE用户ID同步Account
export function oeSynAccount({ userId }) {
  return request({
    url: `${SERVICE.API_MEDIA}/oceanengine/${userId}/accounts/sync`,
    method: 'get'
  })
}

// 查询TT用户列表
export function getTTUsers(params) {
  return request({
    url: `${SERVICE.API_MEDIA}/tiktok/users`,
    method: 'get',
    params
  })
}

// 查询TT上次同步成功时间
export function getTTSynTime({ userId }) {
  return request({
    url: `${SERVICE.API_MEDIA}/tiktok/${userId}/accounts/syncTime`,
    method: 'get',
    params
  })
}

// 查询TT用户下的账号
export function ttPageAccount({ userId }) {
  return request({
    url: `${SERVICE.API_MEDIA}/tiktok/${userId}/accounts`,
    method: 'post',
    data
  })
}

// 按TT用户ID同步Account
export function ttSynAccount({ userId }) {
  return request({
    url: `${SERVICE.API_MEDIA}/tiktok/${userId}/accounts/sync`,
    method: 'get',
  })
}

// 查询KS用户列表
export function getKSUsers(params) {
  return request({
    url: `${SERVICE.API_MEDIA}/kuaishou/users`,
    method: 'get',
    params
  })
}

// 查询KS上次同步成功时间
export function getKSSynTime({ userId }) {
  return request({
    url: `${SERVICE.API_MEDIA}/kuaishou/${userId}/accounts/syncTime`,
    method: 'get',
  })
}

// 查询KS用户下的账号
export function ksPageAccount({ userId }) {
  return request({
    url: `${SERVICE.API_MEDIA}/kuaishou/${userId}/accounts`,
    method: 'post',
    data
  })
}

// 按KS用户ID同步Account
export function ksSynAccount({ userId }) {
  return request({
    url: `${SERVICE.API_MEDIA}/kuaishou/${userId}/accounts/sync`,
    method: 'get',
  })
}

// 获取AF产品列表
export function getAfProducts(data) {
  return request({
    url: `${SERVICE.API_MEDIA}/appsflyer/products`,
    method: 'post',
    data
  })
}

// 关联授权第三方
export function thirdBind(data) {
  return request({
    url: `${SERVICE.API_MEDIA}/mediaOAuth/thirdBind`,
    method: 'post',
    data
  })
}

// 第三方解绑
export function thirdUnbind(data) {
  return request({
    url: `${SERVICE.API_MEDIA}/mediaOAuth/thirdUnbind`,
    method: 'post',
    data
  })
}

// 删除自定义字段
export function deleteField(id) {
  return request({
    url: `${SERVICE.API_MEDIA}/dsTableField/dynamic/${id}`,
    method: 'delete',
  })
}

// 查询自定义字段详情
export function getFieldDetail(id) {
  return request({
    url: `${SERVICE.API_MEDIA}/dsTableField/dynamic/${id}`,
    method: 'get',
  })
}

// 编辑自定义字段
export function editField(data) {
  return request({
    url: `${SERVICE.API_MEDIA}/dsTableField/dynamic`,
    method: 'put',
    data
  })
}

// 新增自定义字段
export function addField(data) {
  return request({
    url: `${SERVICE.API_MEDIA}/dsTableField/dynamic`,
    method: 'post',
    data
  })
}

// 获取表下面的指标
export function metricsByTableIds(tableIds) {
  return request({
    url: `${SERVICE.API_MEDIA}/dsTable/metrics`,
    method: 'post',
    data: { tableIds }
  })
}

// 获取表下面的维度
export function dimensionsByTableIds(tableIds) {
  return request({
    url: `${SERVICE.API_MEDIA}/dsTable/dimensions`,
    method: 'post',
    data: { tableIds }
  })
}

// 获取表下面的数组
export function jsonArrayByTableIds(tableIds) {
  return request({
    url: `${SERVICE.API_MEDIA}/dsTable/jsonArray`,
    method: 'post',
    data: { tableIds }
  })
}

// 数据源下面的表
export function findRecordsetByCode(params) {
  return request({
    url: `${SERVICE.API_MEDIA}/datasource/findRecordsetByCode`,
    method: 'post',
    data: {},
    params
  })
}

// 获取数据源刷新频率
export function getFrequency (params) {
  return request({
    url: `${SERVICE.API_MEDIA}/dsTablePullDataConfig/findFromConfig`,
    method: 'get',
    params
  })
}

// 下载中心列表
export function getFileList (data) {
  return request({
    url: `${SERVICE.API_MEDIA}/file-storage/page`,
    method: 'post',
    data
  })
}

// 下载
export function downloadFile (id) {
  return request({
    url: `${SERVICE.API_MEDIA}/file-storage/download/${id}`,
    method: 'get',
    responseType: "blob",
  })
}


// 智能预警分页
export function intelligentWarningPage (data) {
  return request({
    url: `${SERVICE.API_WARN}/intelligentWarningTask/page`,
    method: 'post',
    data
  })
}

// 智能预警新增
export function addIntelligentWarning (data) {
  return request({
    url: `${SERVICE.API_WARN}/intelligentWarningTask`,
    method: 'post',
    data
  })
}

// 智能预警编辑
export function editIntelligentWarning (data, id) {
  return request({
    url: `${SERVICE.API_WARN}/intelligentWarningTask/${id}`,
    method: 'put',
    data
  })
}

// 智能预警详情
export function intelligentWarningDetails (id) {
  return request({
    url: `${SERVICE.API_WARN}/intelligentWarningTask/${id}`,
    method: 'get',
  })
}

// 智能预警详情
export function warningLogList (data) {
  return request({
    url: `${SERVICE.API_WARN}/intelligentWarningLog/page`,
    method: 'post',
    data
  })
}

// 获取品类
export function getCategory (params) {
  return request({
    url: `${SERVICE.API_MEDIA}/category`,
    method: 'get',
    params
  })
}

// 获取品类
export function getCountry (params) {
  return request({
    url: `${SERVICE.API_MEDIA}/dictCountry`,
    method: 'get',
    params
  })
}
// 上传数据源
export function uploadDataFile (data, type) {
  return request({
    url: `${SERVICE.API_ANALYSIS}/offline-file/upload/${type}`,
    method: 'post',
    data
  })
}
// 下载模板
export function downloadTemplate (type) {
  return request({
    url: `${SERVICE.API_ANALYSIS}/offline-file/download-template/${type}`,
    method: 'get',
    responseType: "blob",
  })
}